import { CircularProgress, styled } from '@mui/material'

const Screen = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  backgroundColor: 'rgba(255, 255, 255, .5)',
  zIndex: theme.zIndex.drawer + 1,
}))

interface Props {
  loadingSize: number
  open: boolean
}
const LoadingCover = ({ loadingSize, open }: Props) => {
  if (!open) {
    return null
  }

  return (
    <Screen>
      <CircularProgress size={loadingSize} />
    </Screen>
  )
}

export default LoadingCover
